module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"breakdown_title":"拆书-","regenerate":"重新生成","download":"下载","copy":"复制","copy_success":"复制成功","copy_fail":"复制失败","copy_error":"复制时出错"},"en":{"breakdown_title":"Breakdown-","regenerate":"Regenerate","download":"Download","copy":"Copy","copy_success":"Copied successfully","copy_fail":"Copy failed","copy_error":"Error copying"}}')
  delete Component.options._Ctor
}
